import React from "react";

import "./cell.styles.scss";

type CellProps = {
  testAttributes: {
    id: string;
  };
  children: React.ReactNode;
};

export const Cell: React.FC<CellProps> = ({ testAttributes, children }) => {
  return (
    <td {...testAttributes} className="SkipLogic__row__field">
      {children}
    </td>
  );
};
